<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg1959"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs1963"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath1973"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path1971" /></clipPath></defs><g
     id="g1965"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g1967"><g
         id="g1969"
         clip-path="url(#clipPath1973)"><g
           id="g1975"
           transform="translate(256,135)"><path
             d="m 0,0 c 0,-66.274 -53.726,-120 -120,-120 -66.274,0 -120,53.726 -120,120 0,66.274 53.726,120 120,120 C -53.726,120 0,66.274 0,0 Z"
             style="fill:none;stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1977" /></g><g
           id="g1979"
           transform="translate(136,15)"><path
             d="m 0,0 h 330 c 16.568,0 30,13.432 30,30 V 381.997 L 260.004,482 H 30 C 13.432,482 0,468.568 0,452 V 240"
             style="fill:none;stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1981" /></g><g
           id="g1983"
           transform="translate(396,497)"><path
             d="M 0,0 V -100 H 100 Z"
             style="fill:none;stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1985" /></g><g
           id="g1987"
           transform="translate(215.3623,225)"><path
             d="M 0,0 H 210.638"
             style="fill:none;stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1989" /></g><g
           id="g1991"
           transform="translate(206,315)"><path
             d="M 0,0 H 220"
             style="fill:none;stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1993" /></g><g
           id="g1995"
           transform="translate(256,135)"><path
             d="M 0,0 H 170"
             style="fill:none;stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1997" /></g><g
           id="g1999"
           transform="translate(181,90)"><path
             d="M 0,0 -90,90"
             style="fill:none;stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2001" /></g><g
           id="g2003"
           transform="translate(91,90)"><path
             d="M 0,0 90,90"
             style="fill:none;stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2005" /></g></g></g></g></svg>
</template>
